<template>
  <div>
    <UserList v-loading="loading" :users="users" :tenantId="userInfo.tenant.id" :group="userInfo.tenant.group" :companyName="userInfo.tenant.companyName" :ownerUserId="ownerUserId" :stripeCustomerId=userInfo.tenant.stripeCustomerId :tenantData="tenantData" @loadData="loadData" @change-owner-user-id="ownerUserId = $event"/>
  </div>
</template>

<script>
import UserList from './components/UserList'
import { mapState } from 'vuex'
import { getTenant } from '@/views/Accident/queries.js'
import { Auth, API } from 'aws-amplify';
import { updateUser, updateTenant } from '@/graphql/mutations'
import { clearVisibleStaffCache } from '@/utilities/visibleStaffSet'
import { updateStripeCustomer } from './utils'
import { backfillLastLogin } from '@/utilities/backfillLastLogin'

export default {
  name: "UserIndex",
  components:{ UserList },
  data(){
    return{
    USER_PERMISSIONS: process.env.VUE_APP_USER_PERMISSIONS === "1",
      users:[],
      loading: false,
      ownerUserId: null,
      tenantData: null
    }
  },

  mounted(){
    this.loadData()
  },

  computed:{
    ...mapState(['userInfo'])
  },

  methods:{
    /** Load user data */
    async loadData(){
      this.loading = true
      try{
        var tenantId = this.userInfo.tenant.id;
        let tenant = await this.api(getTenant, { id: tenantId })
        this.ownerUserId = tenant.data.getTenant?.ownerUserId || null
        this.tenantData = tenant.data.getTenant
        tenant.data.getTenant.users.items = tenant.data.getTenant.users.items.filter(user => !(user.email.startsWith('sysadmin-') && user.email.endsWith('@herasolutions.info')))
        let hasCreator = tenant.data.getTenant.users.items.find(user => user.isCreator)
        let tenantOwnerId = tenant.data.getTenant.ownerUserId
        if(tenant.data.getTenant.users.items.length > 0) {
          if (!hasCreator || !tenantOwnerId) {
            let dates = tenant.data.getTenant.users.items.map((user) => {
              return new Date(user.createdAt)
            })
            let oldDate = new Date(Math.min(...dates))
            let firstUser = tenant.data.getTenant.users.items.find((user) => oldDate.getTime() === new Date(user.createdAt).getTime())
            let input = {
			        id: tenant.data.getTenant.id,		
      		    ownerUserId : firstUser.id,
		        }
            firstUser.isCreator = hasCreator ? false : true
            const updateCreatorResult = await this.api(updateUser, {input: firstUser})
            firstUser.updatedAt = updateCreatorResult.data.updateUser.updatedAt
            
            const findOwner = tenant.data.getTenant.users.items.find(user => user.id === input.ownerUserId)
		        if(findOwner) await updateStripeCustomer(this.tenantData, findOwner.email)
            await this.api(updateTenant, {input: input})
          }
        }
        if(this.USER_PERMISSIONS){
            this.users = await Promise.all(tenant.data.getTenant.users.items.map(async (user) => {
                let newUserLastLogin = user.lastLogin
                if (!user.lastLogin) {
                  newUserLastLogin = await backfillLastLogin(user, this.getCognitoUser.bind(this), this.api.bind(this), updateUser)
                }
                return {
                    ...user,
                    permissionAccidentsString: user.permissionAccidents ? 'Accident Records' : '' ,
                    permissionDocumentsString: user.permissionDocuments ? 'DA Documents' : '' ,
                    permissionDrugTestsString: user.permissionDrugTests ? 'Drug Tests' : '' ,
                    permissionFullAccessString: user.permissionFullAccess ? 'Full Access' : '' ,
                    permissionInjuriesString: user.permissionInjuries ? 'Injury Records' : '' ,
                    permissionLoginString: user.permissionLogin ? 'Login' : '',
                    lastLogin: newUserLastLogin,
                    tenantOwnerId: user.id === tenantOwnerId ? tenantOwnerId : null
                }
            }))       
        }
        else{
            this.users = tenant.data.getTenant.users.items
        }
        this.loading = false
      }catch(e){
        console.error(e)
        this.loading = false
        this.displayUserError(e)
      }
    },

    /** 
     * Gets a single cognito user
     * @param {string} username 
     * */
    async toggleHierarchicalPermissions(value) {
      this.hierarchicalPermissionsLoading = true
      try {
        const input = {
          id: this.userInfo.tenant.id,
          permissionHierarchicalPermissions: value
        }
        await this.api(updateTenant, { input })
        this.$store.commit('setTenant', { ...this.$store.state.userInfo.tenant, permissionHierarchicalPermissions: value })
        clearVisibleStaffCache()
      } catch (error) {
        this.hierarchicalPermissionsToggle = !value
        this.displayUserError(error)
      }
      this.hierarchicalPermissionsLoading = false
    },

    async getCognitoUser(username){
        let apiName = 'AdminQueries';
        let path = '/getUser';
        let myInit = {
            queryStringParameters: {
            "username": username,
            }, 
            headers: {
            'Content-Type' : 'application/json',
            Authorization: `${(await Auth.currentSession()).getAccessToken().getJwtToken()}`
            } 
        }
        var result = await API.get(apiName, path, myInit);
        return result
    },
  }
  
}
</script>
